export default __webpack_public_path__ + "static/media/InfoIcon.83657fdb.svg";